import { useRecoilValue } from 'recoil'
import styled from 'styled-components'

import Caution from '~/features/event-info/components/Caution'
import Cosplay from '~/features/event-info/components/Cosplay'
import DonginMarket from '~/features/event-info/components/DonginMarket'
import FamousCreator from '~/features/event-info/components/FamousCreator'
import LocationAndSchedule from '~/features/event-info/components/LocationAndSchedule'
import MarketBooth from '~/features/event-info/components/MarketBooth'
import SpecialZone from '~/features/event-info/components/SpecialZone'
import Sponser from '~/features/event-info/components/Sponsor'
import StagePerformance from '~/features/event-info/components/StagePerformance'
import { useEventInfoDetail } from '~/features/event-info/queries/event-info'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import NoData from '~/shared/components/NoData'
import { selectedEventIdState } from '~/shared/states'

function EventInfoIntroduction() {
  const selectedEventId = useRecoilValue(selectedEventIdState)
  const { data, isLoading } = useEventInfoDetail(selectedEventId)
  if (!data) return <NoData />
  if (isLoading) return <LoadingScreen />

  const {
    event_time,
    event_date,
    event_application,
    event_caution,
    event_top_image_info,
  } = data!

  const locationAndScheduleInfo = {
    event_time,
    event_date,
    event_application,
    event_caution,
    event_top_image_info,
  }

  const sponsorList = data!.sponsor_list
  const specialZoneList = data!.special_zone_list

  const { event_caution_note, event_caution_etc } = data!

  const caution = {
    event_caution_note,
    event_caution_etc,
  }

  return (
    <Wrapper>
      <LocationAndSchedule locationAndScheduleInfo={locationAndScheduleInfo} />
      <Sponser sponsorList={sponsorList} />
      <DonginMarket />
      <MarketBooth />
      <FamousCreator />
      <StagePerformance />
      <Cosplay />
      <SpecialZone specialZoneList={specialZoneList} />
      <Caution caution={caution} />
    </Wrapper>
  )
}

export default EventInfoIntroduction

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  height: auto;
`
